import { render, staticRenderFns } from "./SettingsButton.vue?vue&type=template&id=70261e41&scoped=true"
import script from "./SettingsButton.vue?vue&type=script&lang=js"
export * from "./SettingsButton.vue?vue&type=script&lang=js"
import style0 from "./SettingsButton.vue?vue&type=style&index=0&id=70261e41&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70261e41",
  null
  
)

export default component.exports